import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';
import { observer } from 'mobx-react';
import { useStore } from '@stores/RootStore';
import { ErrorIcon } from '@icons/ErrorIcon';
import { useGetApprovals } from '@queryHooks/useApproval';
import * as S from './ApprovalCompletedStyles';
import { ApprovalTable } from './ApprovalTable';

export const ApprovalCompleted = observer(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { authStore } = useStore();

  const { data: completedApprovals } = useGetApprovals({
    approverId: authStore.id,
    isStepCompleted: true,
  });

  return (
    <S.Container>
      {completedApprovals?.content?.length ? (
        <S.ApprovalList>
          <ApprovalTable approvals={completedApprovals.content} />
        </S.ApprovalList>
      ) : (
        <S.NoApprovalContainer>
          <S.NoApproval>
            <S.Exclaim>
              <ErrorIcon width={22} height={22} color={theme.colors['ic-primary-light']} />
            </S.Exclaim>
            <strong className="main-text">{t('Approval_Completed_No_Items_Title')}</strong>
            <span className="sub-text">{t('Approval_Completed_No_Items_Description')}</span>
          </S.NoApproval>
        </S.NoApprovalContainer>
      )}
    </S.Container>
  );
});
